import React from 'react'
import { useSelector } from 'react-redux'
import { Icon } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { uhcDeepLinkSelector } from '@src/selectors/app'
import { openUrl } from '@src/utils/openUrl'
import { Card } from './Card'

export const UhcNoCallsLeftCard = () => {
  const styles = useStyleSheet(themedStyles)
  const uhcDeepLinks = useSelector(uhcDeepLinkSelector)

  const onPress = () => {
    openUrl(uhcDeepLinks.storeUrl)
  }

  return (
    <Card
      icon={<Icon name="warning" size={48} weight="fill" style={styles.icon} />}
      title="0 Calls Left"
      description="You've completed all of your coaching calls this month."
      buttonTitle="Go to the UHC Store"
      onCardPress={onPress}
      onButtonPress={onPress}
    />
  )
}

const themedStyles = StyleService.create({
  icon: {
    color: 'theme.warning.base',
  },
})
